import type { CommerceIntentDto } from "@zipper/customer-commerce-client";
import { fromPromise } from "xstate";
import type {
  CancelIntentInput,
  CheckoutGateway,
  ConfirmIntentInput,
  CreateIntentInput,
  RecoverIntentInput,
} from "./contracts";
import { runCheckoutActor } from "./timeout";

export interface CreateIntentActorInput extends CreateIntentInput {
  gateway: CheckoutGateway;
}

export interface ConfirmIntentActorInput extends ConfirmIntentInput {
  gateway: CheckoutGateway;
}

export interface RecoverIntentActorInput extends RecoverIntentInput {
  gateway: CheckoutGateway;
}

export interface CancelIntentActorInput extends CancelIntentInput {
  gateway: CheckoutGateway;
}

export const createIntentActor = fromPromise<
  CommerceIntentDto,
  CreateIntentActorInput
>(async ({ input, signal }) =>
  runCheckoutActor(signal, (derivedSignal) =>
    input.gateway.createIntent({
      runtime: input.runtime,
      request: input.request,
      signal: derivedSignal,
    }),
  ),
);

export const confirmIntentActor = fromPromise<
  CommerceIntentDto,
  ConfirmIntentActorInput
>(async ({ input, signal }) =>
  runCheckoutActor(signal, (derivedSignal) =>
    input.gateway.confirmIntent({
      runtime: input.runtime,
      request: input.request,
      signal: derivedSignal,
    }),
  ),
);

export const recoverIntentActor = fromPromise<
  CommerceIntentDto,
  RecoverIntentActorInput
>(async ({ input, signal }) =>
  runCheckoutActor(signal, (derivedSignal) =>
    input.gateway.recoverIntent({
      runtime: input.runtime,
      intentId: input.intentId,
      signal: derivedSignal,
    }),
  ),
);

export const cancelIntentActor = fromPromise<
  CommerceIntentDto,
  CancelIntentActorInput
>(async ({ input, signal }) =>
  runCheckoutActor(signal, (derivedSignal) =>
    input.gateway.cancelIntent({
      runtime: input.runtime,
      request: input.request,
      signal: derivedSignal,
    }),
  ),
);
